import request from './request';

export const marketApi = {
  getMarketGroup() {
    return request({
      url: '/trade/market/group',
      method: 'get',
    });
  },
  getMarketList() {
    return request({
      url: '/trade/market/list',
      method: 'get',
    });
  },
  getMarketHotList() {
    return request({
      url: '/trade/market/hot',
      method: 'get',
    });
  },
  getMarketPair() {
    return request({
      url: '/trade/market/pair',
      method: 'get',
    });
  },
};
